export enum Role {
	owner = "owner",
	decisionMaker = "decision-maker",
	decisionReceiver = "decision-receiver",
}

export const roles = Object.values(Role);

export enum UserRoles {
	ROLE_ROOT = "ROLE_ROOT",
	ROLE_ADMIN = "ROLE_ADMIN",
	ROLE_USER = "ROLE_USER",
}

export const userRoles = [
	{ value: UserRoles.ROLE_ROOT, label: "Root" },
	{ value: UserRoles.ROLE_ADMIN, label: "Admin" },
	{ value: UserRoles.ROLE_USER, label: "User" },
];

export type UserRole = typeof userRoles;
